export const crisisResources = [
  {
    title: 'Immediate danger',
    text: 'If someone may be hurt soon, contact local emergency services now. Do not wait for a reply here.',
    href: '',
  },
  {
    title: 'Find local crisis support',
    text: 'Use Find a Helpline to locate free, confidential support in your country.',
    href: 'https://findahelpline.com/',
  },
  {
    title: 'Talk to a qualified professional',
    text: 'For medical, legal, financial, or safety decisions, use Cyberautography as shared experience, not professional advice.',
    href: '',
  },
];
